import React, { ChangeEvent, useState } from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import {
  Entity,
  ResponseGetParametrizacaoEfeitvo
} from 'pages/Supplier/MovMensal/types'
import { FORMAT } from 'utils'

import ModalNovaAddEfetivo from '../ModalNovaAddEfetivo/ModalNovaAddEfetivo'
import { useMovement } from 'hooks'

export interface ITableVisaoIndividual {
  tableData: Entity[]
  deleteEfetivo?: (_id) => void
  updateEfetivo?: (_data, _index) => void
  dadosParametrizacao: ResponseGetParametrizacaoEfeitvo | undefined
  bloquearAcoes: boolean
  isCompetenciaAtual: boolean
  competenciaAtual?: string
  listaAtual?: Entity[]
}

const TableVisaoIndividual: React.FC<ITableVisaoIndividual> = ({
  tableData,
  updateEfetivo,
  deleteEfetivo,
  dadosParametrizacao,
  bloquearAcoes,
  isCompetenciaAtual,
  competenciaAtual,
  listaAtual
}) => {
  const {
    dataAtuacaoInvalida,
    isSomenteCompartilhado,
  } = useMovement()

  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const [showEditEfetivo, setShowEditEfetivo] = useState<boolean>(false)
  const [efetivoIndex, setEfetivoIndex] = useState<number>()

  const optsCategoria = {
    A: 'ADMINISTRATIVO',
    O: 'OPERACIONAL'
  }

  const optsNacionalidade = {
    B: 'BRASILEIRO',
    E: 'ESTRANGEIRO'
  }

  const optsGenero = {
    F: 'FEMININO',
    M: 'MASCULINO',
    O: 'Prefiro não informar'
  }

  const isDisableIcon = (): boolean => {
    const disableIcon = true
    const enableIcon = false

    if ([
      bloquearAcoes,
      !isCompetenciaAtual,
      dataAtuacaoInvalida
    ].includes(true)) {
      return disableIcon
    }

    return enableIcon
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center" padding="checkbox">
                Linha
              </TableCellStyled>
              <TableCellStyled align="center">Nacionalidade</TableCellStyled>
              <TableCellStyled align="center">CPF/Passaporte</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Gênero
              </TableCellStyled>
              <TableCellStyled align="center">Nome</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Status
              </TableCellStyled>
              <TableCellStyled align="center">Data Admissão</TableCellStyled>
              <TableCellStyled align="center">Data Demissão</TableCellStyled>
              <TableCellStyled align="center">Tipo Efetivo</TableCellStyled>
              <TableCellStyled align="center">Função</TableCellStyled>
              <TableCellStyled align="center">Categoria</TableCellStyled>
              <TableCellStyled align="center">Competência</TableCellStyled>
              <TableCellStyled align="center">Compartilhados</TableCellStyled>
              {dadosParametrizacao?.flValorHeSalarioBasePorColaborador && (
                <TableCellStyled align="center">
                  Valor Hora Extra
                </TableCellStyled>
              )}
              {dadosParametrizacao?.flValorHeSalarioBasePorColaborador && (
                <TableCellStyled align="center">Salário Base</TableCellStyled>
              )}

              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.length === 0 ? (
              <TableRowStyled>
                <TableCellStyled align="center" colSpan={16}>
                  Não possui dados nesta competencia
                </TableCellStyled>
              </TableRowStyled>
            ) : (
              (rowsPerPage > 0
                ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                : tableData
              )?.map((el, index) => (
                <TableRowStyled
                  key={el?.nmColaborador?.toString() + index?.toString()}
                >
                  <TableCellStyled align="center">
                    {el?.index || '- - - -'}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {optsNacionalidade[
                      el?.cdNacionalidade?.trim().toUpperCase()
                    ] || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.documento(el.cdCpfPassaporte) || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {optsGenero[el.cdGenero?.trim().toUpperCase()] || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {el.nmColaborador?.trim() || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {el.cdStatus.toUpperCase() || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.formatDDMMYYYY(el.dtAdmissao) || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {(el.dtDemissao && FORMAT.formatDDMMYYYY(el.dtDemissao)) ||
                      '- - - -'}
                  </TableCellStyled> <TableCellStyled align="center">
                    {el.cdTipoEfetivo?.trim() || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {el.txFuncao?.trim() || '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {optsCategoria[el?.cdCategoria?.trim().toUpperCase()] ||
                      '- - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.competencia(el?.nuAnoMesCompetencia || el.nuMesAnoCompetencia) ||
                      '- - - -'}
                  </TableCellStyled>
                  {/* // TODO */}
                  <TableCellStyled align="center">{el?.cdContrato || '- - - - '}</TableCellStyled>
                  {dadosParametrizacao?.flValorHeSalarioBasePorColaborador && (
                    <TableCellStyled align="center">
                      {FORMAT.currency(el.vlHoraExtras) || '- - - -'}
                    </TableCellStyled>
                  )}
                  {dadosParametrizacao?.flValorHeSalarioBasePorColaborador && (
                    <TableCellStyled align="center">
                      {FORMAT.currency(el.vlSalBase) || '- - - -'}
                    </TableCellStyled>
                  )}
                  <TableCellStyled align="center">
                    <EditIcon
                      cursor={bloquearAcoes ? 'default' : 'pointer'}
                      onClick={() => {
                        setEfetivoIndex(el.index)
                        setShowEditEfetivo(true)
                      }}
                      disabled={isDisableIcon()}
                    />
                    <DeleteIcon
                      cursor={bloquearAcoes ? 'default' : 'pointer'}
                      onClick={() => deleteEfetivo(el?.index)}
                      disabled={isDisableIcon()}
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))
            )}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
      {!!showEditEfetivo && (
        <ModalNovaAddEfetivo
          data={
            tableData[
            tableData?.findIndex((elTable) => elTable?.index === efetivoIndex)
            ]
          }
          showModal={showEditEfetivo}
          toggleModal={() => setShowEditEfetivo(false)}
          onSubmit={(data) => updateEfetivo(data, efetivoIndex)}
          competenciaAtual={competenciaAtual}
          dadosParametrizacao={dadosParametrizacao}
          listaAtual={listaAtual}
        />
      )}
    </>
  )
}

export default TableVisaoIndividual
